import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import MdViewer from '../markdown/MdViewer';

export interface TermsOfUseDialogProps {
  onClose: () => void;
  open: boolean;
}

const TermsOfUseDialog = ({ onClose, open }: TermsOfUseDialogProps) => {
  const { data: terms } = useQuery<string>({ queryKey: [{ isPublic: true, path: 'trust-center/terms-of-use' }] });

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <MdViewer text={terms}></MdViewer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TermsOfUseDialog;
